export default __webpack_public_path__ + "static/media/Group9171.ae1d2e29.svg";